// Liking needs an account: send a signed-out visitor to sign up, then back here.
export const signUpPath = (returnTo: string) =>
  `/users/sign_up?return_to=${encodeURIComponent(returnTo)}`
